// extracted by mini-css-extract-plugin
export var quillEditor = "_o2-1";
export var variable = "_o2-0";